// A tiny, optional "plink" made with the Web Audio API (no sound files). Off unless the person turns it on.
let ctx: AudioContext | null = null;

export function chime(enabled: boolean): void {
  if (!enabled) return;
  try {
    ctx = ctx ?? new AudioContext();
    const now = ctx.currentTime;
    [523.25, 659.25, 783.99].forEach((f, i) => {
      const osc = ctx!.createOscillator();
      const gain = ctx!.createGain();
      osc.type = "sine";
      osc.frequency.value = f;
      gain.gain.setValueAtTime(0.0001, now + i * 0.11);
      gain.gain.exponentialRampToValueAtTime(0.18, now + i * 0.11 + 0.02);
      gain.gain.exponentialRampToValueAtTime(0.0001, now + i * 0.11 + 0.7);
      osc.connect(gain).connect(ctx!.destination);
      osc.start(now + i * 0.11);
      osc.stop(now + i * 0.11 + 0.75);
    });
  } catch {
    /* audio blocked: silence is fine */
  }
}
